
export enum ValueAddedServiceCode {
  LogisticsService= 'LogisticsService',
  ProvisionalLicensePlate= 'ProvisionalLicensePlate',
  VehicleNationalization= 'VehicleNationalization',
  VehicleRegistration= 'VehicleRegistration',
  PowertrainWarranty= 'PowertrainWarranty',
  FleequidCare= 'FleequidCare',

}